// extracted by mini-css-extract-plugin
export var breadcrumbs = "breadcrumbs-module--breadcrumbs--x6pTq";